import { createElement, forwardRef, useEffect, useMemo, useRef, useState } from "react";
import classNames from 'classnames';
import './index.scss';
const prefixCls = 'au-switch';
const ColorfulSwitch = forwardRef(({ checked, defaultChecked, disabled, onChange, onClick, checkedText, uncheckedText, ..._otherProps }, ref) => {
    const [isChecked, setIsChecked] = useState(Boolean(defaultChecked));
    const nativeRef = useRef(null);
    useEffect(() => {
        setIsChecked(checked);
    }, [checked]);
    const wrapClassNames = useMemo(() => {
        return classNames([prefixCls, isChecked && `${prefixCls}-checked`, disabled && `${prefixCls}-disabled`]);
    }, [isChecked, disabled]);
    const handleClick = (e) => {
        if (disabled)
            return;
        setIsChecked(!isChecked);
        if (onChange) {
            onChange(!isChecked);
        }
    };
    return (createElement("div", { ..._otherProps, className: wrapClassNames, onClick: handleClick, ref: ref || nativeRef },
        createElement("div", { className: "au-switch-checkbox" },
            createElement("div", { className: "au-switch-handle" }),
            createElement("div", { className: "au-switch-inner" }, isChecked ? checkedText : uncheckedText))));
});
ColorfulSwitch.displayName = 'ColorfulSwitch';
export default ColorfulSwitch;
